import React from 'react';
import { AssetIcon } from '../../../shared/assets';
import { Link } from 'react-router-dom';
import {
  Target,
  CheckCircle,
  PieChart,
} from '../../../shared/assets/AppIcons';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/shared/ui/card';
import { Badge } from '@/shared/ui/badge';
import { getRoutePath, ROUTE_IDS } from '@/app/router/route-registry';
import { formatCurrency } from '@/modules/dashboard/utils/dashboard.helpers';
import '@/modules/dashboard/styles/DealsOverviewSection.css';

export default function DealsOverviewSection({ dealSummary }) {
  const proposalsPath = getRoutePath(ROUTE_IDS.DEAL_PROPOSALS);
  const inProgressPath = getRoutePath(ROUTE_IDS.DEALS_IN_PROGRESS);
  const completedPath = getRoutePath(ROUTE_IDS.DEALS_COMPLETED);

  return (
    <Card className="deals-overview">
      <CardHeader>
        <div className="deals-overview__header">
          <div>
            <CardTitle className="deals-overview__title">
              <PieChart className="deals-overview__title-icon" size={16} />
              KPI Principali
            </CardTitle>
            <CardDescription className="deals-overview__description">
              Affari per stato e valore
            </CardDescription>
          </div>
        </div>
      </CardHeader>

      <CardContent>
        <div className="deals-overview__stack">
          <Link to={proposalsPath} className="deals-overview__link">
            <div className="deals-overview__item deals-overview__item--proposal">
              <div className="deals-overview__item-header">
                <div className="deals-overview__item-info">
                  <div className="deals-overview__item-icon-wrap deals-overview__item-icon-wrap--proposal">
                    <Target size={16} className="deals-overview__item-icon deals-overview__item-icon--proposal" />
                  </div>
                  <div>
                    <h4 className="deals-overview__item-title">Proposte</h4>
                    <p className="deals-overview__item-description">Affari in fase di proposta</p>
                  </div>
                </div>

                <Badge className="deals-overview__count-badge deals-overview__count-badge--proposal">
                  {dealSummary.proposalsCount}
                </Badge>
              </div>

              <div className="deals-overview__item-footer deals-overview__item-footer--proposal">
                <span className="deals-overview__item-footer-label deals-overview__item-footer-label--proposal">
                  Valore Totale
                </span>
                <span className="deals-overview__item-footer-value deals-overview__item-footer-value--proposal">
                  {formatCurrency(dealSummary.proposalsValue)}
                </span>
              </div>
            </div>
          </Link>

          <Link to={inProgressPath} className="deals-overview__link">
            <div className="deals-overview__item deals-overview__item--progress">
              <div className="deals-overview__item-header">
                <div className="deals-overview__item-info">
                  <div className="deals-overview__item-icon-wrap deals-overview__item-icon-wrap--progress">
                    <AssetIcon name="status.inProgress" size={16} className="deals-overview__item-icon deals-overview__item-icon--progress" />
                  </div>
                  <div>
                    <h4 className="deals-overview__item-title">In Corso</h4>
                    <p className="deals-overview__item-description">Affari in lavorazione</p>
                  </div>
                </div>

                <Badge className="deals-overview__count-badge deals-overview__count-badge--progress">
                  {dealSummary.inProgressCount}
                </Badge>
              </div>

              <div className="deals-overview__item-footer deals-overview__item-footer--progress">
                <span className="deals-overview__item-footer-label deals-overview__item-footer-label--progress">
                  Valore Totale
                </span>
                <span className="deals-overview__item-footer-value deals-overview__item-footer-value--progress">
                  {formatCurrency(dealSummary.inProgressValue)}
                </span>
              </div>
            </div>
          </Link>

          <Link to={completedPath} className="deals-overview__link">
            <div className="deals-overview__item deals-overview__item--completed">
              <div className="deals-overview__item-header">
                <div className="deals-overview__item-info">
                  <div className="deals-overview__item-icon-wrap deals-overview__item-icon-wrap--completed">
                    <CheckCircle size={16} className="deals-overview__item-icon deals-overview__item-icon--completed" />
                  </div>
                  <div>
                    <h4 className="deals-overview__item-title">Completati</h4>
                    <p className="deals-overview__item-description">Affari conclusi con successo</p>
                  </div>
                </div>

                <Badge className="deals-overview__count-badge deals-overview__count-badge--completed">
                  {dealSummary.completedCount}
                </Badge>
              </div>

              <div className="deals-overview__item-footer deals-overview__item-footer--completed">
                <span className="deals-overview__item-footer-label deals-overview__item-footer-label--completed">
                  Valore Totale
                </span>
                <span className="deals-overview__item-footer-value deals-overview__item-footer-value--completed">
                  {formatCurrency(dealSummary.completedValue)}
                </span>
              </div>
            </div>
          </Link>
        </div>

        <div className="deals-overview__total">
          <div className="deals-overview__total-row">
            <span className="deals-overview__total-label">Valore Totale Pipeline</span>
            <span className="deals-overview__total-value">
              {formatCurrency(dealSummary.totalPipelineValue)}
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
